<template>
  <div @dragover="dragover"
       @dragleave="dragleave"
       @drop="drop"
       class="dropzone" id="main">

    <h3 v-if="active">{{ this.filelist[0].name }}</h3>
    <h3 v-else>Drag or Drop File</h3>

    <h3 :class="{ hidden: active }">OR</h3>

    <label :class="{ hidden: active }" for="dropzoneFile">Select File</label>
    <button :class="{ hidden: !active }" @click="remove()">Remove</button>
    <input type="file" id="dropzoneFile" class="dropzoneFile" ref="file" @change="onChange"/>
  </div>
</template>

<script>

export default {
  name: 'DropZone',

  data () {
    return {
      active: false,
      dropzoneFile: {},
      filelist: []
    };
  },
  methods: {
    onChange () {
      this.filelist = [...this.$refs.file.files];
      document.getElementById('main').classList.add('active-dropzone');
      this.active = true;
      this.$emit('uploaded', this.filelist);
    },
    remove () {
      this.active = false;
      this.filelist = [];
      document.getElementById('main').classList.remove('active-dropzone');
    },
    dragover (event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('active-dropzone')) {
        event.currentTarget.classList.add('active-dropzone');
      }
    },
    dragleave (event) {
      // Clean up
      event.currentTarget.classList.remove('active-dropzone');
    },
    drop (event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
    }
  }
};
</script>

<style scoped lang="scss">
.dropzone {
  width: 400px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
  border: 2px dashed #F35647;
  background-color: #fff;
  transition: 0.3s ease all;

  label {
    padding: 8px 12px;
    color: #fff;
    background-color: #F35647;
    transition: 0.3s ease all;
  }

  input {
    display: none;
  }
}

.hidden {
  display: none;
}

.active-dropzone {
  color: #fff;
  border-color: #fff;
  background-color: #F35647;

  label {
    background-color: #fff;
    color: #F35647;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/DropZone.vue